import { locales } from './locales';
export const SUPPORTED_LOCALES = locales;
/**
 * Get all supported locales
 */
export function getAllLocales() {
    return SUPPORTED_LOCALES;
}
/**
 * Get all supported locale ISO codes
 */
export function getSupportedLocaleIsoCodes() {
    return SUPPORTED_LOCALES.map((locale) => locale.langIso);
}
/**
 * Check if a locale ISO code is supported
 */
export function isLocaleSupported(langIso) {
    return SUPPORTED_LOCALES.some((locale) => locale.langIso === langIso);
}
/**
 * Get locale by ISO code
 */
export function getLocaleByIso(langIso) {
    return SUPPORTED_LOCALES.find((locale) => locale.langIso === langIso);
}
/**
 * Get most common locales for better UX performance
 */
export function getCommonLocales() {
    return [
        'en_US',
        'en_GB',
        'es_ES',
        'fr_FR',
        'de_DE',
        'it_IT',
        'pt_PT',
        'pt_BR',
        'ru_RU',
        'zh_CN',
        'zh_TW',
        'ja_JP',
        'ko_KR',
        'ar_SA',
        'hi_IN',
        'nl_NL',
        'sv_SE',
        'da_DK',
        'no_NO',
        'fi_FI',
        'pl_PL',
        'tr_TR',
        'cs_CZ',
        'hu_HU',
        'ro_RO',
    ];
}
/**
 * Normalize locale string (convert hyphens to underscores)
 */
export function normalizeLocale(locale) {
    return locale.replace(/-/g, '_');
}
//# sourceMappingURL=locale-registry.js.map